import { Card } from "react-bootstrap";

import Layout from "../../components/Layout/Layout";

export default function NotFoundPage() {
    return (
        <Layout>
            <Card.Body className="p-4">
                <title>Nothing here... | MyCorvus</title>
                <Card.Text>Nothing here...</Card.Text>
            </Card.Body>
        </Layout>
    );
}
